<template>
  <div
    class="vx-card vessel-card"
    :class="{
      'vessel-card-caution': hasCaution,
      'vessel-card-warning': hasWarning,
      'empty-crew': isEmptyCrew,
    }"
  >
    <div class="vx-card-header">
      <span class="vx-card-title">{{ vesselName }}</span>
      <div class="info-icon-container" v-if="hasWarning || hasCaution">
        <vx-tooltip-with-slot-text position="bottom">
          <!-- ホバー時に表示するツールチップ -->
          <template v-slot:text>
            <tooltip-crew-assignment-alert :alerts="vesselAlertInfo" />
          </template>
          <!-- ホバー対象 -->
          <template v-slot:inner>
            <span
              class="material-icons alert-icon cursor-pointer"
              :class="{
                warning: hasWarning,
                caution: hasCaution,
              }"
            >
              error
            </span>
          </template>
        </vx-tooltip-with-slot-text>
      </div>
    </div>
    <div class="vx-card-body">
      <crew-card
        class="crew-card"
        v-for="role in flattenedRoles"
        :key="role.id"
        :role="role"
        :crew-errors="crewError(role)"
        :now-date="nowDate"
      />
    </div>
  </div>
</template>

<script>
import VxTooltipWithSlotText from "@/layouts/components/vx-tooltip/VxTooltipWithSlotText.vue";
import { TooltipCrewAssignmentAlert } from "./tooltips";
import CrewCard from "./CrewCard.vue";

export default {
  name: "VesselCard",
  components: { CrewCard, VxTooltipWithSlotText, TooltipCrewAssignmentAlert },
  props: {
    vessel: {
      type: Object,
      required: true,
    },
    crews: {
      type: Array,
      required: true,
    },
    crewsRoles: {
      type: Array,
      required: true,
    },
    vesselAlert: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      name: this.vessel.name,
      roles: this.vessel.manning_vessel_roles,
      nowDate: new Date(),
    };
  },
  computed: {
    isEmptyCrew() {
      return (
        this.flattenedRoles.filter(role => !role.crewInfo).length ===
        this.flattenedRoles.length
      );
    },
    hasCaution() {
      return (
        Array.isArray(this.vesselAlert.alert_info) &&
        this.vesselAlert.alert_info.some(info => info.alert_type === "CAUTION")
      );
    },
    hasWarning() {
      return (
        Array.isArray(this.vesselAlert.alert_info) &&
        this.vesselAlert.alert_info.some(info => info.alert_type === "WARNING")
      );
    },
    crewsRolesMap() {
      return this.crewsRoles.reduce((map, role) => {
        map[role.id] = role;
        return map;
      }, {});
    },
    crewsMap() {
      return this.crews.reduce((map, crew) => {
        map[
          crew.current_manning_vessel_crew.enterprise_manning_vessel_crew_roles[0].enterprise_manning_vessel_role_position_id
        ] = crew;
        return map;
      }, {});
    },
    flattenedRoles() {
      if (!this.roles || !Array.isArray(this.roles)) return [];

      const sortedRoles = this.roles
        .filter(role => {
          const roleData =
            this.crewsRolesMap &&
            this.crewsRolesMap[role.enterprise_crew_role_id];
          return !!role && !!roleData;
        })
        .map(role => {
          const roleData = this.crewsRolesMap[role.enterprise_crew_role_id];
          const positions = Array.isArray(role.manning_vessel_role_positions)
            ? [...role.manning_vessel_role_positions]
            : [];

          return {
            ...role,
            sort_order: roleData.sort_order,
            manning_vessel_role_positions: positions.sort(
              (a, b) => a.sort_order - b.sort_order
            ),
          };
        })
        .sort((a, b) => a.sort_order - b.sort_order);

      return sortedRoles.flatMap(role => {
        const roleInfo =
          (this.crewsRolesMap && this.crewsRolesMap[role.id]) || {};
        const positions = Array.isArray(role.manning_vessel_role_positions)
          ? role.manning_vessel_role_positions
          : [];

        return positions
          .map(position => {
            const crewInfo =
              (this.crewsMap && this.crewsMap[position.id]) || {};
            return {
              ...position,
              role: roleInfo,
              crewInfo: crewInfo,
            };
          })
          .filter(role => {
            return Object.keys(role.crewInfo).length != 0;
          });
      });
    },
    vesselAlertInfo() {
      if (this.vesselAlert && Array.isArray(this.vesselAlert.alert_info)) {
        return this.vesselAlert.alert_info;
      }
      return [];
    },
    vesselName() {
      const text = this.vessel.name;
      const maxLength = 8;
      return text.length > maxLength ? text.slice(0, maxLength) + "…" : text;
    },
  },
  methods: {
    crewError(role) {
      return role.crewInfo.alerts;
    },
  },
};
</script>

<style lang="scss" scoped>
.vessel-card-caution {
  background-color: #ffeebd;
}
.vessel-card-warning {
  background-color: #ffcccc;
}
.vessel-card {
  width: 174px;
  padding: 12px;
  font-size: 12px;
  &.empty-crew {
    height: 40px;
  }
  .vx-card-header {
    position: relative;
    .vx-card-title {
      font-size: 14px;
      line-height: 1;
    }

    .info-icon-container {
      width: 14px;
      height: 14px;
      position: absolute;
      top: 0;
      right: 0;
      .alert-icon {
        font-size: 16px;
        &.warning {
          color: #e02e22;
        }
        &.caution {
          color: #ffd400;
        }
      }
    }
  }

  .vx-card-body {
    .crew-card {
      margin-top: 4px;
    }
  }
}
</style>
